import React, { useState, useMemo } from 'react';
import {
  Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, 
  TableRow, TableSortLabel, TextField, Dialog, DialogTitle, DialogContent, IconButton,
  Typography
} from '@mui/material';
import { visuallyHidden } from '@mui/utils'; 
import PrintIcon from '@mui/icons-material/Print';

const headCells = [
  { id: 'product_id', label: 'شمیره' },
  { id: 'product_name', label: 'نوم' },
  { id: 'batchnumber', label: 'Batch No.' },
  { id: 'product_code', label: 'Formula' },
  { id: 'expiry_date', label: 'Expiray Date' },
];

export default function SupplierTable({ rows }) {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('expiry_date');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
    const [printOpen, setPrintOpen] = useState(false); // To keep the original product data
  const [filters, setFilters] = useState({
    product_id: '',
    product_name: '',
    batchnumber: '',
    product_code: '',
    expiry_date: '',
  });

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  // Sorting & Filtering Logic
  const handleRequestSort = (event, property) => {
    //console.log(printOpen)
    // setPrintOpen(true)
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleFilterChange = (event, column) => {
    setFilters((prev) => ({ ...prev, [column]: event.target.value }));
  };

  const filteredRows = useMemo(() => {
    return rows
      .filter((row) =>
        Object.keys(filters).every((key) =>
          row[key]?.toString().toLowerCase().includes(filters[key].toLowerCase())
        )
      )
      .sort((a, b) =>
        order === 'asc'
          ? a[orderBy] < b[orderBy] ? -1 : 1
          : a[orderBy] > b[orderBy] ? -1 : 1
      );
  }, [rows, filters, order, orderBy]);

  // Handle Click on Row
  const handleRowClick = (transaction) => {
    //console.log(transaction)
    setPrintOpen(true)
    setSelectedTransaction(transaction);
    setOpenDialog(true);
  };

  const printBill = () => {
    setPrintOpen(false)
    
}
const handlePrint = () => { 
            // const rows = capital 
        try {
        if (!rows || rows.length === 0)
            return alert("No rows to print.");

        const storeInfo = {
            logo: localStorage.getItem("businessLogo") || "",
            businessName: localStorage.getItem("businessName"),
        };

        const printWindow = window.open("", "_blank");

        // const footerRemarks = `<tr><td colspan=4>ټوټل بیلینس	 </td> <td> ${totalBalance}</td></tr>`

        const newTableRows = rows
            .map(
            (row) => `
            <tr> 
                <td style="text-align:left;"> ${row?.expiry_date}  </td> 
                <td>${row?.product_code || ""}</td>
                <td>${row?.batchnumber || ""}</td>
                <td>${row?.product_name || ""}</td>
                <td style="direction:ltr;">${row?.updated_at  || ""}</td>
            </tr>`
            )
            .join("");

        const logoPath = storeInfo.logo
            ? storeInfo.logo
            : "/images/logos/Logo.png";

        const styles = `
        <style>
            @page {
            size: A4;
            margin: 15mm;
            }
            body {
            font-family: 'Noto Naskh Arabic', sans-serif;
            margin: 0;
            background-color: white;
            background-repeat: no-repeat;
            background-position: center 50%;
            background-size: 60%;
            -webkit-print-color-adjust: exact !important;
            }
            .page {
              width: 210mm;
              min-height: 297mm;
              padding: 10px;          /* ✅ 10px left & right */
              box-sizing: border-box;
            }
            table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            }
            th, td {
            border: 1px solid #ddd;
            padding: 4px;
            text-align: center;
            }
            thead {
            display: table-header-group; 
            color: white;
            }
            tbody tr:nth-child(odd) {
            background-color: #f9f9f9;
            }
            .header-info {
            text-align: center;
            font-size: 13px;
            padding: 4px 0;
            }
            .logo {
            max-width: 60px;
            }
            footer {
            text-align: center;
            font-size: 11px;
            margin-top: 10px;
            }
        </style>
        `;

        const printHTML = `
        <html lang="ps">
            <head>
            <meta charset="UTF-8" />
            <title>واصلي ټیکنالوژي</title>
            ${styles}
            </head>
            <body>
  <div class="page">
    <table>
                <thead>
                    <tr style="color: black">
                    <td colspan="6" class="header-info" style="border:0px">
                        <div style="display:flex; justify-content:space-between; align-items:center;">
                        <div style="float: right; text-align: right;">
                        <h3 style="margin: 0; padding:0px; font-size: 12px">
                            Expiry Date List 
                        </h3>
                            </div>
                        <div style="text-align:left;">
                            <img src="${logoPath}" class="logo" />
                            <h2 style="font-size:12px; margin:0;">${storeInfo.businessName || ""}</h2>
                        </div>
                        </div>
                    </td>
                    </tr>
                    <tr style="background-color: #ffa800">
                    <th>Expiry Date</th> 
                    <th>Formula</th> 
                    <th>Batch No.</th>
                    <th>نوم</th>
                    <th>تاریخ</th>
                    </tr>
                </thead>
                <tbody>
                    ${newTableRows}
                </tbody>
                </table>
            </div>

            <footer>© ${new Date().getFullYear()} ${"واصلي ټیکنالوژي 0703131865"}</footer>

            <script>
                window.onload = () => {
                window.print();
                window.onafterprint = () => window.close();
                };
            </script>
            </body>
        </html>
        `;

        printWindow.document.open();
        printWindow.document.write(printHTML);
        printWindow.document.close();
        } catch (err) {
        console.error("Error printing bill:", err);
        }
    };
  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Typography variant="h6" gutterBottom style={{direction:'ltr'}}>
                  <IconButton aria-label="print" onClick={handlePrint}>
                  <PrintIcon />
                  </IconButton> 
          </Typography>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={'medium'}>
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} sortDirection={orderBy === headCell.id ? order : false}>
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={(event) => handleRequestSort(event, headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
                 {/* <TableCell>کړنې</TableCell> */}
              </TableRow>
              {/* Search Input Row */}
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id}>
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      value={filters[headCell.id]}
                      onChange={(event) => handleFilterChange(event, headCell.id)}
                      placeholder={`لټون ${headCell.label}`}
                    />
                  </TableCell>
                ))}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                <TableRow 
                  hover 
                  key={row.product_id} 
                  // onClick={() => handleRowClick(row)} 
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>{row.product_id}</TableCell>
                  <TableCell>{row.product_name}</TableCell>
                  <TableCell>{row.batchnumber}</TableCell>
                  <TableCell>{row.product_code}</TableCell>
                  <TableCell
                    style={{ color: row.payment_method === 'LOAN' ? 'red' : 'inherit' }}
                  >
                    {row.payment_method === 'LOAN'
                      ? `-${row.expiry_date} `
                      : `${row.expiry_date} `}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </Paper> 
    </Box>
  );
}
